// tslint:disable
/// <reference path="../custom.d.ts" />
/**
 * Reposit API
 * The Reposit API
 *
 * The version of the OpenAPI document: 2.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import globalAxios, { AxiosPromise, AxiosInstance } from 'axios';
import { Configuration } from '../configuration';
import { BASE_PATH, COLLECTION_FORMATS, RequestArgs, BaseAPI, RequiredError } from '../base';

import { CreateOrganizationGroupDTO } from '../models';
import { OrganizationGroupDTO } from '../models';
import { SearchOrganizationGroupOrganizationsResultsDTO } from '../models';
import { SearchOrganizationGroupResultDTO } from '../models';
import { SearchUnusedOrganizationGroupsResultsDTO } from '../models';
/**
 * OrganizationGroupsApi - axios parameter creator
 * @export
 */
export const OrganizationGroupsApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * Create an organization group
         * @param {CreateOrganizationGroupDTO} createOrganizationGroupDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationGroup(createOrganizationGroupDTO: CreateOrganizationGroupDTO, options: any = {}): RequestArgs {
            // verify required parameter 'createOrganizationGroupDTO' is not null or undefined
            if (createOrganizationGroupDTO === null || createOrganizationGroupDTO === undefined) {
                throw new RequiredError('createOrganizationGroupDTO','Required parameter createOrganizationGroupDTO was null or undefined when calling createOrganizationGroup.');
            }
            const localVarPath = `/v2/organization-groups`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};
            const needsSerialization = (<any>"CreateOrganizationGroupDTO" !== "string") || localVarRequestOptions.headers['Content-Type'] === 'application/json';
            localVarRequestOptions.data =  needsSerialization ? JSON.stringify(createOrganizationGroupDTO !== undefined ? createOrganizationGroupDTO : {}) : (createOrganizationGroupDTO || "");

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Delete an unused organization group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationGroup(id: string, options: any = {}): RequestArgs {
            // verify required parameter 'id' is not null or undefined
            if (id === null || id === undefined) {
                throw new RequiredError('id','Required parameter id was null or undefined when calling deleteOrganizationGroup.');
            }
            const localVarPath = `/v2/organization-groups/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'DELETE', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Search non-private organizations for organization group management
         * @param {number} page 
         * @param {number} size 
         * @param {string} [query] 
         * @param {boolean} [incomplete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizationGroupOrganizations(page: number, size: number, query?: string, incomplete?: boolean, options: any = {}): RequestArgs {
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling searchOrganizationGroupOrganizations.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling searchOrganizationGroupOrganizations.');
            }
            const localVarPath = `/v2/organization-groups/organizations`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (incomplete !== undefined) {
                localVarQueryParameter['incomplete'] = incomplete;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * Search organization groups by name
         * @param {string} query 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizationGroups(query: string, limit: number, options: any = {}): RequestArgs {
            // verify required parameter 'query' is not null or undefined
            if (query === null || query === undefined) {
                throw new RequiredError('query','Required parameter query was null or undefined when calling searchOrganizationGroups.');
            }
            // verify required parameter 'limit' is not null or undefined
            if (limit === null || limit === undefined) {
                throw new RequiredError('limit','Required parameter limit was null or undefined when calling searchOrganizationGroups.');
            }
            const localVarPath = `/v2/organization-groups/search`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (query !== undefined) {
                localVarQueryParameter['query'] = query;
            }

            if (limit !== undefined) {
                localVarQueryParameter['limit'] = limit;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
        /**
         * List unused organization groups
         * @param {number} page 
         * @param {number} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUnusedOrganizationGroups(page: number, size: number, options: any = {}): RequestArgs {
            // verify required parameter 'page' is not null or undefined
            if (page === null || page === undefined) {
                throw new RequiredError('page','Required parameter page was null or undefined when calling searchUnusedOrganizationGroups.');
            }
            // verify required parameter 'size' is not null or undefined
            if (size === null || size === undefined) {
                throw new RequiredError('size','Required parameter size was null or undefined when calling searchUnusedOrganizationGroups.');
            }
            const localVarPath = `/v2/organization-groups/unused`;
            const localVarUrlObj = new URL(localVarPath, 'http://placeholder');
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }
            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            if (page !== undefined) {
                localVarQueryParameter['page'] = page;
            }

            if (size !== undefined) {
                localVarQueryParameter['size'] = size;
            }


    
            Object.entries({...localVarQueryParameter, ...options.query}).forEach(([key, value]) => {
                if (value !== undefined) {
                    localVarUrlObj.searchParams.set(key, String(value));
                }
            });
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...options.headers};

            return {
                url: localVarUrlObj.pathname + localVarUrlObj.search,
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * OrganizationGroupsApi - functional programming interface
 * @export
 */
export const OrganizationGroupsApiFp = function(configuration?: Configuration) {
    return {
        /**
         * Create an organization group
         * @param {CreateOrganizationGroupDTO} createOrganizationGroupDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationGroup(createOrganizationGroupDTO: CreateOrganizationGroupDTO, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<OrganizationGroupDTO> {
            const localVarAxiosArgs = OrganizationGroupsApiAxiosParamCreator(configuration).createOrganizationGroup(createOrganizationGroupDTO, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Delete an unused organization group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationGroup(id: string, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Response> {
            const localVarAxiosArgs = OrganizationGroupsApiAxiosParamCreator(configuration).deleteOrganizationGroup(id, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Search non-private organizations for organization group management
         * @param {number} page 
         * @param {number} size 
         * @param {string} [query] 
         * @param {boolean} [incomplete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizationGroupOrganizations(page: number, size: number, query?: string, incomplete?: boolean, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchOrganizationGroupOrganizationsResultsDTO> {
            const localVarAxiosArgs = OrganizationGroupsApiAxiosParamCreator(configuration).searchOrganizationGroupOrganizations(page, size, query, incomplete, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * Search organization groups by name
         * @param {string} query 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizationGroups(query: string, limit: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<SearchOrganizationGroupResultDTO>> {
            const localVarAxiosArgs = OrganizationGroupsApiAxiosParamCreator(configuration).searchOrganizationGroups(query, limit, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
        /**
         * List unused organization groups
         * @param {number} page 
         * @param {number} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUnusedOrganizationGroups(page: number, size: number, options?: any): (axios?: AxiosInstance, basePath?: string) => AxiosPromise<SearchUnusedOrganizationGroupsResultsDTO> {
            const localVarAxiosArgs = OrganizationGroupsApiAxiosParamCreator(configuration).searchUnusedOrganizationGroups(page, size, options);
            return (axios: AxiosInstance = globalAxios, basePath: string = BASE_PATH) => {
                const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
                return axios.request(axiosRequestArgs);
            };
        },
    }
};

/**
 * OrganizationGroupsApi - factory interface
 * @export
 */
export const OrganizationGroupsApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    return {
        /**
         * Create an organization group
         * @param {CreateOrganizationGroupDTO} createOrganizationGroupDTO 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        createOrganizationGroup(createOrganizationGroupDTO: CreateOrganizationGroupDTO, options?: any) {
            return OrganizationGroupsApiFp(configuration).createOrganizationGroup(createOrganizationGroupDTO, options)(axios, basePath);
        },
        /**
         * Delete an unused organization group
         * @param {string} id 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        deleteOrganizationGroup(id: string, options?: any) {
            return OrganizationGroupsApiFp(configuration).deleteOrganizationGroup(id, options)(axios, basePath);
        },
        /**
         * Search non-private organizations for organization group management
         * @param {number} page 
         * @param {number} size 
         * @param {string} [query] 
         * @param {boolean} [incomplete] 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizationGroupOrganizations(page: number, size: number, query?: string, incomplete?: boolean, options?: any) {
            return OrganizationGroupsApiFp(configuration).searchOrganizationGroupOrganizations(page, size, query, incomplete, options)(axios, basePath);
        },
        /**
         * Search organization groups by name
         * @param {string} query 
         * @param {number} limit 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchOrganizationGroups(query: string, limit: number, options?: any) {
            return OrganizationGroupsApiFp(configuration).searchOrganizationGroups(query, limit, options)(axios, basePath);
        },
        /**
         * List unused organization groups
         * @param {number} page 
         * @param {number} size 
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        searchUnusedOrganizationGroups(page: number, size: number, options?: any) {
            return OrganizationGroupsApiFp(configuration).searchUnusedOrganizationGroups(page, size, options)(axios, basePath);
        },
    };
};

/**
 * OrganizationGroupsApi - interface
 * @export
 * @interface OrganizationGroupsApi
 */
export interface OrganizationGroupsApiInterface {
    /**
     * Create an organization group
     * @param {CreateOrganizationGroupDTO} createOrganizationGroupDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationGroupsApiInterface
     */
    createOrganizationGroup(createOrganizationGroupDTO: CreateOrganizationGroupDTO, options?: any): AxiosPromise<OrganizationGroupDTO>;

    /**
     * Delete an unused organization group
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationGroupsApiInterface
     */
    deleteOrganizationGroup(id: string, options?: any): AxiosPromise<{}>;

    /**
     * Search non-private organizations for organization group management
     * @param {number} page 
     * @param {number} size 
     * @param {string} [query] 
     * @param {boolean} [incomplete] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationGroupsApiInterface
     */
    searchOrganizationGroupOrganizations(page: number, size: number, query?: string, incomplete?: boolean, options?: any): AxiosPromise<SearchOrganizationGroupOrganizationsResultsDTO>;

    /**
     * Search organization groups by name
     * @param {string} query 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationGroupsApiInterface
     */
    searchOrganizationGroups(query: string, limit: number, options?: any): AxiosPromise<Array<SearchOrganizationGroupResultDTO>>;

    /**
     * List unused organization groups
     * @param {number} page 
     * @param {number} size 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationGroupsApiInterface
     */
    searchUnusedOrganizationGroups(page: number, size: number, options?: any): AxiosPromise<SearchUnusedOrganizationGroupsResultsDTO>;

}

/**
 * OrganizationGroupsApi - object-oriented interface
 * @export
 * @class OrganizationGroupsApi
 * @extends {BaseAPI}
 */
export class OrganizationGroupsApi extends BaseAPI implements OrganizationGroupsApiInterface {
    /**
     * Create an organization group
     * @param {CreateOrganizationGroupDTO} createOrganizationGroupDTO 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationGroupsApi
     */
    public createOrganizationGroup(createOrganizationGroupDTO: CreateOrganizationGroupDTO, options?: any) {
        return OrganizationGroupsApiFp(this.configuration).createOrganizationGroup(createOrganizationGroupDTO, options)(this.axios, this.basePath);
    }

    /**
     * Delete an unused organization group
     * @param {string} id 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationGroupsApi
     */
    public deleteOrganizationGroup(id: string, options?: any) {
        return OrganizationGroupsApiFp(this.configuration).deleteOrganizationGroup(id, options)(this.axios, this.basePath);
    }

    /**
     * Search non-private organizations for organization group management
     * @param {number} page 
     * @param {number} size 
     * @param {string} [query] 
     * @param {boolean} [incomplete] 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationGroupsApi
     */
    public searchOrganizationGroupOrganizations(page: number, size: number, query?: string, incomplete?: boolean, options?: any) {
        return OrganizationGroupsApiFp(this.configuration).searchOrganizationGroupOrganizations(page, size, query, incomplete, options)(this.axios, this.basePath);
    }

    /**
     * Search organization groups by name
     * @param {string} query 
     * @param {number} limit 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationGroupsApi
     */
    public searchOrganizationGroups(query: string, limit: number, options?: any) {
        return OrganizationGroupsApiFp(this.configuration).searchOrganizationGroups(query, limit, options)(this.axios, this.basePath);
    }

    /**
     * List unused organization groups
     * @param {number} page 
     * @param {number} size 
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof OrganizationGroupsApi
     */
    public searchUnusedOrganizationGroups(page: number, size: number, options?: any) {
        return OrganizationGroupsApiFp(this.configuration).searchUnusedOrganizationGroups(page, size, options)(this.axios, this.basePath);
    }

}

/**
 * Standalone tree-shakeable functions for OrganizationGroupsApi
 * Import individual functions for optimal bundle size
 */
/**
 * Create an organization group
 * @param {CreateOrganizationGroupDTO} createOrganizationGroupDTO 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function createOrganizationGroup(
    createOrganizationGroupDTO: CreateOrganizationGroupDTO,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<OrganizationGroupDTO> {
    const localVarAxiosArgs = OrganizationGroupsApiAxiosParamCreator(configuration).createOrganizationGroup(createOrganizationGroupDTO, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Delete an unused organization group
 * @param {string} id 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function deleteOrganizationGroup(
    id: string,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<void> {
    const localVarAxiosArgs = OrganizationGroupsApiAxiosParamCreator(configuration).deleteOrganizationGroup(id, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Search non-private organizations for organization group management
 * @param {number} page 
 * @param {number} size 
 * @param {string} [query] 
 * @param {boolean} [incomplete] 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchOrganizationGroupOrganizations(
    page: number,
    size: number,
    query?: string,
    incomplete?: boolean,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SearchOrganizationGroupOrganizationsResultsDTO> {
    const localVarAxiosArgs = OrganizationGroupsApiAxiosParamCreator(configuration).searchOrganizationGroupOrganizations(page, size, query, incomplete, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * Search organization groups by name
 * @param {string} query 
 * @param {number} limit 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchOrganizationGroups(
    query: string,
    limit: number,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<Array<SearchOrganizationGroupResultDTO>> {
    const localVarAxiosArgs = OrganizationGroupsApiAxiosParamCreator(configuration).searchOrganizationGroups(query, limit, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

/**
 * List unused organization groups
 * @param {number} page 
 * @param {number} size 
 * @param {Configuration} [configuration] Optional configuration
 * @param {AxiosInstance} [axios] Optional axios instance
 * @param {string} [basePath] Optional base path
 * @param {*} [options] Override http request option.
 * @throws {RequiredError}
 */
export async function searchUnusedOrganizationGroups(
    page: number,
    size: number,
    configuration?: Configuration,
    axios: AxiosInstance = globalAxios,
    basePath: string = BASE_PATH,
    options?: any
): Promise<SearchUnusedOrganizationGroupsResultsDTO> {
    const localVarAxiosArgs = OrganizationGroupsApiAxiosParamCreator(configuration).searchUnusedOrganizationGroups(page, size, options);
    const axiosRequestArgs = {...localVarAxiosArgs.options, url: basePath + localVarAxiosArgs.url};
    const __response = await axios.request(axiosRequestArgs);
    return __response.data;
}

